import { useMemo } from 'react';
import { PostStepperDto } from '@libs/dto';
import { JobPreview } from '@carcareers/components';
import { useForm } from '@carcareers/contexts';
import { Job, Rooftop } from '@libs/models';

export const JobPreviewStepForm = () => {
  const { data } = useForm<PostStepperDto>();

  const job = useMemo(() => {
    const jobDetails: Partial<Job> = data?.job ? { ...data.job } : {};

    if (!jobDetails.rooftop && data?.rooftop) {
      jobDetails.rooftop = data.rooftop as Rooftop;
    }

    return jobDetails as Job;
  }, [data?.job, data?.rooftop]);
  
  return <JobPreview data={job} descriptionFillHeight />;
};